export enum UserChannelEvents {
  NewConversation = 'new_conversation',
  ReassignConversation = 'reassign_conversation',
  AssigneeUpdate = 'assignee_update',
  StatusUpdate = 'status_update',
  NewMessage = 'new_message',
  NotifyChime = 'notify_chime',
  ConversationParticipantsUpdate = 'conversation_participants_update',
  NewNonqliqMessage = 'new_nonqliq_message',
  MarkChatUserPresence = 'mark_chat_user_presence',
  MarkChatUserCurrentTab = 'mark_chat_user_current_tab',
}

export enum ConversationChannelEvents {
  MarkRead = 'mark_read',
  MarkDelivered = 'mark_delivered',
  IsTyping = 'is_typing',
  FileUploadFinished = 'file_upload_finished',
  CreateMessagePc = 'pc:create_message',
  CreateMessageVc = 'vc:create_message',
  MarkAssigneeAcknowledged = 'mark_assignee_acknowledged',
  VideoChatCancel = 'video_chat_cancel',
}

export enum ConversationNotificationEvents {
  TypingEvent = 'typing_event',
  MessageEvent = 'message_event',
  ParticipantEvent = 'participant_event',
  StatusEvent = 'status_event',
}

export enum BotNotificationChannelEvents {
  Notification = 'notification',
}

export enum NotificationChannelEvents {
  Notification = 'notification',
}

export enum VisitPathChannelEvents {
  Ping = 'PING',
  ClockIn = 'CLOCK_IN',
}
